
import {PropType} from "vue";
import {InternetDiscountPopinDto} from "../../cart/models/InternetDiscountPopinDto";
import Bouton from "../ob1/Bouton.vue";

export default {
    name: "DiscountPopinIntroShared",
    components: {
        Bouton
    },
    props: {
        activeView: {
            type: String,
            required: true
        },
        dto: {
            type: Object as PropType<InternetDiscountPopinDto>,
            required: true
        },
        emitAddOfferClick: {
            type: Boolean,
            required: false,
            default: false
        },
        enableContinueWithoutDiscount: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        onAddOfferClick() {
            const redirectUrl = this.dto.introContent.addButton.href;
            if (!redirectUrl) {
                return;
            }
            if (this.emitAddOfferClick) {
                this.$emit('add-offer-click', redirectUrl);
                return;
            }
            window.location.href = redirectUrl;
        },
        onShowFormClick() {
            this.$emit('update:activeView', 'form');
        },
        onContinueWithoutDiscountClick(event: Event) {
            if (event) {
                event.preventDefault();
            }
            const redirectUrl = this.dto.introContent.continueWithoutDiscountButton
                && this.dto.introContent.continueWithoutDiscountButton.href;
            if (redirectUrl) {
                this.$emit('continue-without-discount-click', redirectUrl);
            }
        }
    }
}
